import { RecipientsGetterTypes } from './types';

export const getters = {
    [RecipientsGetterTypes.GetRecipients](state) {
        return (state.recipients && state.recipients.data) || []
    },
    [RecipientsGetterTypes.GetResponse](state) {
        return state.recipients
    },
    [RecipientsGetterTypes.GetPerPage](state) {
        return state.per_page
    }
}